require('./publicPath');
require('@fortawesome/fontawesome-free/css/all.css');
